import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const ArrowUpIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue5d8'}</MuiIcon>
    );
}
